module.exports = __webpack_public_path__ + "static/media/geschichte-garten.04c87a31.jpg";